import { PLAN_STATIC_CONFIG, PlanConfig } from '@/features/pricing/constants/plans-config';

import {
	ISFetchPlansResponse,
	ISFetchPlansResponsePlan,
} from '@/shared/services/payment/payment.types';

// Joins the dynamic country-specific pricing response with the static
// feature/copy data. Output matches the existing PlanConfig[] shape so the
// downstream components (PlanCard, pricing-section, plans-page) need no
// further changes.
export function mergePlansWithStaticConfig(dynamic: ISFetchPlansResponse): PlanConfig[] {
	const byPlanType = new Map<string, ISFetchPlansResponsePlan>();
	for (const plan of dynamic.plans) {
		byPlanType.set(plan.planType, plan);
	}

	return PLAN_STATIC_CONFIG.map((staticEntry) => {
		const monthlyDynamic = byPlanType.get(staticEntry.planIds.monthly);
		const yearlyDynamic = byPlanType.get(staticEntry.planIds.yearly);

		return {
			name: staticEntry.name,
			features: staticEntry.features,
			buttonText: staticEntry.buttonText,
			planIds: staticEntry.planIds,
			priceSubtext: staticEntry.priceSubtext,
			prices: {
				monthly: monthlyDynamic?.displayLabel ?? staticEntry.staticPrice ?? '',
				yearly: yearlyDynamic?.displayLabel ?? staticEntry.staticPrice ?? '',
			},
			stripePriceIds: {
				monthly: monthlyDynamic?.stripePriceId ?? null,
				yearly: yearlyDynamic?.stripePriceId ?? null,
			},
		} satisfies PlanConfig;
	});
}
